import StepCard from "./components/StepCard";
import createJobImg from "../../../assets/img/apponboarding/create-job.png";
import createTaskImg from "../../../assets/img/apponboarding/create_task.png";

const StepCreateJob = ({ onCtaClick, onSkip, stepNumber, selectedOrganization }) => {
  const isOperation = selectedOrganization?.type === "operation";
  const ctaLabel = isOperation ? "Create Task" : "Create Job";
  return (
  <StepCard
    stepLabel={`Step ${stepNumber}`}
    title={`Create Your First ${isOperation ? "Task" : "Job"}`}
    description={`${isOperation ? "Tasks" : "Jobs"} represent service work assigned to technicians in the field.`}
    ctaLabel={ctaLabel}
    onCtaClick={onCtaClick}
    onSkip={onSkip}
    mediaSrc={null}
    selectedOrganization={selectedOrganization}
    backgroundColor="#FAF5F2"
    backgroundImage={isOperation ? createTaskImg : createJobImg}
    videoUrl={isOperation ? "https://youtu.be/nycVJK8smzk" : "https://youtu.be/4Ox9TCQSLxw"}
  />
  );
};
export default StepCreateJob;
